import * as React from 'react';
import { ActivityBannerType, ActivityDetailBasic } from '../../../common/__generated__/api';
import { MessageBanner } from '.';

export interface InfositeMessageBannerProps {
  message: ActivityDetailBasic.Banners;
}

export const InfositeMessageBanner: React.FC<InfositeMessageBannerProps> = ({ message }) => {
  const linkText = message.action && message.action.text;
  const linkUrl = message.action && message.action.href;
  const linkRfrr = message.action && message.action.rfrr;

  const renderDiscountBanner = (): JSX.Element => {
    switch (message.type) {
      case ActivityBannerType.ALERT:
        return (
          <MessageBanner
            key={'banner-info-alert'}
            headerText={message.title}
            bodyText={message.subtitle}
            className={'s-x-padding-three all-b-margin-three'}
            icon={message.icon}
            mark={message.mark}
            linkUrl={linkUrl}
            linkText={linkText}
            linkRfrr={linkRfrr}
          />
        );
      case ActivityBannerType.SHOP_WITH_POINTS:
        return (
          <MessageBanner
            key={'banner-swp'}
            headerText={message.title}
            bodyText={message.subtitle}
            className={'s-x-padding-three all-b-margin-three'}
          />
        );
      default:
        return <></>;
    }
  };

  return renderDiscountBanner();
};
